orders_translations = {
    "orders": {
        en: "Orders",
        cn: "订单",
        es: "Pedidos",
        pt: "Pedidos",
        ru: "Заказы",
    },
    "id": {
        en: "ID",
        cn: "ID",
        es: "ID",
        pt: "ID",
        ru: "Идентификатор",
    },
    "find_your_order_id_in_the_confirmation_email_sent_to_you_by_gulfstream.": {
        en: "Find your Order ID in the confirmation email sent to you by Gulfstream.",
        cn: "在湾流发送给您的确认电邮中找到您的订单ID。",
        es: "Encuentre la ID de su pedido en el correo de confirmación que Gulfstream le envió.",
        pt: "Encontre a ID do seu pedido no e-mail de confirmação enviado pela Gulfstream.",
        ru: "Идентификатор вашего заказа указан в подтверждении, отправленном Gulfstream по электронной почте.",
    },
    "no_order_with_that_id_was_found.": {
        en: "No order with that ID was found.",
        cn: "未找到该ID对应的订单。",
        es: "No se encontraron pedidos con esa ID.",
        pt: "Não foi encontrado nenhum pedido com essa ID.",
        ru: "Заказов с указанным идентификатором не найдено.",
    },
    "order_information": {
        en: "Order Information",
        cn: "订单信息",
        es: "Información del pedido",
        pt: "Outras informações",
        ru: "Информация о заказе",
    },
    "from": {
        en: "From",
        cn: "从",
        es: "Desde",
        pt: "De",
        ru: "От",
    },
    "requested_assets": {
        en: "Requested Assets",
        cn: "请求的资产",
        es: "Activos solicitados",
        pt: "Ativos solicitados",
        ru: "Запрошенные ресурсы",
    },
    "processing": {
        en: "Processing",
        cn: "处理中",
        es: "Procesando",
        pt: "Processando",
        ru: "В обработке",
    },
    "processed": {
        en: "Processed",
        cn: "已处理",
        es: "Procesado",
        pt: "Processado",
        ru: "Обработано",
    },
    "message": {
        en: "Message",
        cn: "留言",
        es: "Mensaje",
        pt: "Mensagem",
        ru: "Сообщение",
    },
    "approved": {
        en: "Approved",
        cn: "批准",
        es: "Aprobado",
        pt: "Aprovado",
        ru: "Одобрено",
    },
    "denied": {
        en: "Denied",
        cn: "拒绝",
        es: "Denegado",
        pt: "Negado",
        ru: "Отклонено",
    },
    "expired": {
        en: "Expired",
        cn: "过期",
        es: "Vencido",
        pt: "Expirado",
        ru: "Срок истек",
    },
    "expires": {
        en: "Expires",
        cn: "有效期",
        es: "Vence el",
        pt: "Expira",
        ru: "Срок истекает",
    },
    "your_gulfstream_news_media_request_has_been_updated": {
        en: "Your Gulfstream News Media Request has been updated",
        cn: "您的“湾流新闻媒体请求”已更新",
        es: "Su solicitud de medios de Noticias de Gulfstream ha sido actualizada",
        pt: "Seu pedido de mídia de notícias da Gulfstream foi atualizado",
        ru: "Ваш запрос на доступ к новостным ресурсам Gulfstream обновлен",
    },
    "this_email_is_to_notify_you_of_an_update_to_your_request_for_gulfstream_media_assets.": {
        en: "This email is to notify you of an update to your request for Gulfstream media assets.",
        cn: "本邮件旨在提醒您湾流媒体资产的请求有更新。",
        es: "Este correo es para notificarle sobre una actualización de su solicitud de activos de medios de Gulfstream.",
        pt: "Este e-mail tem a finalidade de notificar sobre uma atualização ao seu pedido de ativos de mídia da Gulfstream.",
        ru: "Уведомляем вас об обновлении вашего запроса на доступ к новостным ресурсам Gulfstream.",
    },
    "you_can_visit_this_link_to_download_approved_assets": {
        en: "You can visit this link to download approved assets",
        cn: "您可以访问该链接，下载批准的资产",
        es: "Puede visitar este enlace para descargar los activos aprobados",
        pt: "Você pode visitar este link para fazer o download de seus ativos aprovados",
        ru: "Для загрузки одобренных ресурсов перейдите по ссылке",
    },
};
